/**
 * ページ共通JS
 */
// 画像・動画遅延読み込み
import objectFitImages from 'object-fit-images'
objectFitImages()

// スムーススクロール
import smoothScroll from './component/smoothScroll'
smoothScroll()

// 画像・動画遅延読み込み
import lazyRoad from './component/lazyRoad'
lazyRoad()

// ドロワーメニュー
import drawerMenu from './component/drawerMenu'
drawerMenu()

// 山行実績のテーブル
import trackRecordTabel from './component/trackRecordTabel'
trackRecordTabel()
